'use client';

import { useTranslations } from 'next-intl';
import { Container } from '@//components/Container';
import { Heading } from '@//components/Heading';
import { Hero } from '@//components/Hero';
import { FaqSearchBar } from '../FaqSearchBar';
import styles from './FaqHero.module.scss';

export const FaqHero: React.FC = () => {
  const t = useTranslations('pages.faq.hero');

  return (
    <Hero ariaLabelledby="faq-hero-heading">
      <Container size="tight">
        <div className={styles.wrapper}>
          <Heading level={1} size="4xl" font="brand" id="faq-hero-heading">
            {t('heading')}
          </Heading>
          <FaqSearchBar tone="surface" />
        </div>
      </Container>
    </Hero>
  );
};
